import { render, staticRenderFns } from "./Inscription.vue?vue&type=template&id=bab21d40&scoped=true"
import script from "./Inscription.vue?vue&type=script&lang=js"
export * from "./Inscription.vue?vue&type=script&lang=js"
import style0 from "./Inscription.vue?vue&type=style&index=0&id=bab21d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab21d40",
  null
  
)

export default component.exports